import { render, staticRenderFns } from "./my-import-contacts-popup.vue?vue&type=template&id=752dd098&scoped=true&"
import script from "./my-import-contacts-popup.vue?vue&type=script&lang=js&"
export * from "./my-import-contacts-popup.vue?vue&type=script&lang=js&"
import style0 from "./my-import-contacts-popup.vue?vue&type=style&index=0&id=752dd098&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752dd098",
  null
  
)

export default component.exports